/* Review carousels (owner request 27 Oct 2026).
   [data-bw-carousel="loop"]  homepage "In their words": the list is printed twice, so the row
                              scrolls smoothly forever and wraps without a jump.
   [data-bw-carousel="step"]  Judge.me reviews on product pages: Judge.me draws the cards (and can
                              redraw them on sort/filter), so the row moves one card at a time and
                              goes back to the start after the last card.
   Both: left/right arrows, click-and-drag with a mouse, native swipe on touch, pause button,
   pause while hovered / touched / dragged, no auto-scroll with prefers-reduced-motion, and no
   work while off screen or in a background tab. Arabic pages auto-scroll the other way. */
(function () {
  'use strict';
  if (window.__bwCarousel) return;
  window.__bwCarousel = true;

  var RTL = document.documentElement.getAttribute('dir') === 'rtl';
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function reduced() { return !!(mq && mq.matches); }
  var RESUME_MS = 3500;

  /* ---------- shared: pause state, hover/touch hold, visibility ---------- */
  function Controller(root) {
    var self = this;
    this.root = root;
    this.paused = false;   // pause button
    this.hold = 0;         // >0 while hovered, touched, dragged or just after an arrow press
    this.visible = true;
    this.resumeTimer = null;

    var toggle = root.querySelector('.bw-car-toggle');
    if (toggle) {
      toggle.addEventListener('click', function () {
        self.paused = !self.paused;
        root.classList.toggle('is-paused', self.paused);
        toggle.setAttribute('aria-pressed', self.paused ? 'true' : 'false');
        toggle.setAttribute('aria-label', toggle.getAttribute(self.paused ? 'data-label-play' : 'data-label-pause'));
      });
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { self.visible = es[0].isIntersecting; }).observe(root);
    }
    var stage = root.querySelector('.bw-car-stage') || root;
    stage.addEventListener('mouseenter', function () { self.grab('hover'); });
    stage.addEventListener('mouseleave', function () { self.release('hover', 0); });
    stage.addEventListener('touchstart', function () { self.grab('touch'); }, { passive: true });
    stage.addEventListener('touchend', function () { self.release('touch', RESUME_MS); }, { passive: true });
    // Keyboard focus only: a mouse click also focuses the arrow, and that must not freeze the row.
    stage.addEventListener('focusin', function (e) {
      var kb = true;
      try { kb = e.target.matches(':focus-visible'); } catch (err) {}
      if (kb) self.grab('focus');
    });
    stage.addEventListener('focusout', function () { self.release('focus', 0); });
    this.holds = {};
  }
  Controller.prototype.grab = function (why) {
    clearTimeout(this.resumeTimer);
    this.holds[why] = true;
  };
  Controller.prototype.release = function (why, delay) {
    var self = this;
    if (!delay) { delete self.holds[why]; return; }
    this.resumeTimer = setTimeout(function () { delete self.holds[why]; }, delay);
  };
  Controller.prototype.nudge = function () { // after an arrow press, wait before moving again
    this.grab('arrow');
    this.release('arrow', RESUME_MS);
  };
  Controller.prototype.canRun = function () {
    if (this.paused || reduced() || !this.visible || document.hidden) return false;
    for (var k in this.holds) if (this.holds[k]) return false;
    return true;
  };

  /* ---------- shared: mouse drag on a scroller (touch uses native scrolling) ---------- */
  function enableDrag(getScroller, area, ctl, onMove) {
    var el = null, lastX = 0, startX = 0, moved = false, down = false;
    area.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      el = getScroller();
      if (!el || !el.contains(e.target)) return;
      if (e.target.closest('a, button, input, select, textarea, label, video')) return;
      down = true; moved = false; startX = lastX = e.clientX;
      ctl.grab('drag');
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      if (!moved && Math.abs(e.clientX - startX) > 5) { moved = true; el.classList.add('is-dragging'); }
      if (!moved) return;
      el.scrollLeft -= (e.clientX - lastX);
      lastX = e.clientX;
      if (onMove) onMove();
      e.preventDefault();
    });
    function end() {
      if (!down) return;
      down = false;
      if (el) el.classList.remove('is-dragging');
      ctl.release('drag', RESUME_MS);
      if (moved) setTimeout(function () { moved = false; }, 0);
    }
    window.addEventListener('pointerup', end);
    window.addEventListener('pointercancel', end);
    area.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); }
    }, true);
    area.addEventListener('dragstart', function (e) { if (down) e.preventDefault(); });
  }

  function smooth() { return reduced() ? 'auto' : 'smooth'; }

  /* ---------- loop mode (homepage) ---------- */
  function initLoop(root) {
    var vp = root.querySelector('.bw-car-scroller');
    var groups = vp ? vp.querySelectorAll('.bw-rc__group') : [];
    if (!vp || groups.length < 2) return;
    var ctl = new Controller(root);
    var secs = parseFloat(root.getAttribute('data-secs')) || 7;
    var dir = RTL ? -1 : 1;

    function half() { return groups[1].offsetLeft - groups[0].offsetLeft; }
    function step() {
      var c = vp.querySelector('.bw-rc__card');
      if (!c) return 300;
      var cs = getComputedStyle(c);
      return c.getBoundingClientRect().width + (parseFloat(cs.marginRight) || 0);
    }
    function wrap() {
      var w = half();
      if (w <= 0) return;
      if (vp.scrollLeft >= w) vp.scrollLeft -= w;
      else if (vp.scrollLeft < 1) vp.scrollLeft += w;
    }

    var pos = null, last = 0;
    function frame(t) {
      var dt = last ? Math.min(t - last, 64) / 1000 : 0;
      last = t;
      if (ctl.canRun()) {
        var w = half();
        if (pos === null || Math.abs(vp.scrollLeft - pos) > 2) pos = vp.scrollLeft;
        pos += dir * (step() / secs) * dt;
        if (pos >= w) pos -= w;
        if (pos < 1) pos += w;
        vp.scrollLeft = pos;
      } else {
        pos = null;
      }
      requestAnimationFrame(frame);
    }

    vp.addEventListener('scroll', function () { if (!ctl.canRun()) wrap(); }, { passive: true });
    enableDrag(function () { return vp; }, vp, ctl, wrap);

    root.querySelectorAll('.bw-car-arrow').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var n = parseInt(btn.getAttribute('data-step'), 10) || 1;
        var s = step(), w = half(), target = vp.scrollLeft + n * s;
        if (target > w + 1) { vp.scrollLeft -= w; target -= w; }
        if (target < 1) { vp.scrollLeft += w; target += w; }
        ctl.nudge();
        vp.scrollTo({ left: target, behavior: smooth() });
      });
    });

    if (RTL) vp.scrollLeft = half();
    requestAnimationFrame(frame);
  }

  /* ---------- step mode (Judge.me on product pages) ---------- */
  function initStep(root) {
    var ctl = new Controller(root);
    var INTERVAL = (parseFloat(root.getAttribute('data-secs')) || 5) * 1000;
    var arrows = root.querySelectorAll('.bw-car-arrow');
    var bar = root.querySelector('.bw-jrc__bar');
    var started = false;

    function scroller() { return root.querySelector('.jdgm-masonry-grid__container'); }
    function cardStep(sc) {
      var items = sc.querySelectorAll('.jdgm-masonry-grid__masonry-item');
      if (!items.length) return sc.clientWidth;
      var gap = parseFloat(getComputedStyle(sc).columnGap) || 0;
      return items[0].getBoundingClientRect().width + gap;
    }
    function maxLeft(sc) { return Math.max(0, sc.scrollWidth - sc.clientWidth); }

    function move(n) {
      var sc = scroller();
      if (!sc) return;
      var max = maxLeft(sc), s = cardStep(sc), cur = sc.scrollLeft, target;
      if (n > 0) target = cur >= max - 4 ? 0 : Math.min(max, cur + s);
      else target = cur <= 4 ? max : Math.max(0, cur - s);
      sc.scrollTo({ left: target, behavior: smooth() });
    }

    // Arrows centred on the row of cards, shown only when the cards overflow.
    function layout() {
      var sc = scroller();
      var fits = !sc || maxLeft(sc) < 4;
      arrows.forEach(function (a) { a.hidden = fits; });
      if (bar) bar.hidden = fits;
      if (!sc) return;
      var stage = root.querySelector('.bw-car-stage');
      var top = sc.getBoundingClientRect().top - stage.getBoundingClientRect().top + sc.clientHeight / 2;
      stage.style.setProperty('--bw-car-arrow-top', Math.round(top) + 'px');
    }

    arrows.forEach(function (btn) {
      btn.addEventListener('click', function () {
        ctl.nudge();
        move(parseInt(btn.getAttribute('data-step'), 10) || 1);
      });
    });
    enableDrag(scroller, root, ctl);

    function start() {
      if (started) { layout(); return; }
      var sc = scroller();
      if (!sc || !sc.querySelector('.jdgm-masonry-grid__masonry-item')) return;
      started = true;
      if (RTL) sc.scrollLeft = maxLeft(sc);
      layout();
      setInterval(function () { if (ctl.canRun()) move(RTL ? -1 : 1); }, INTERVAL);
    }

    // Judge.me renders after page load and may redraw on sort/filter.
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; start(); });
    }).observe(root, { childList: true, subtree: true });
    window.addEventListener('resize', layout);
    window.addEventListener('load', start);
    start();
  }

  function boot() {
    document.querySelectorAll('[data-bw-carousel]').forEach(function (root) {
      if (root.__bwCar) return;
      root.__bwCar = true;
      if (root.getAttribute('data-bw-carousel') === 'step') initStep(root);
      else initLoop(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
